import { CareerScoutStarters } from "./CareerScoutStarters";
import { Box, Heading } from "../../../../../mads";
import { useI18n } from "../../../../../shared/I18n";
import { ViewJobDivider } from "../Divider";

import { colors, spacing } from "@indeed/ifl-tokens/react-native";
import React from "react";
import { StyleSheet } from "react-native";

/**
 * Standalone "Ask Career Scout" section that appears above Match Overview when
 * `career_scout_always_aware` is in the `separate` bucket. Holds starter chips.
 */
export const AskCareerScoutStartersSection: React.FC = () => {
  const gt = useI18n();

  return (
    <>
      <Box sx={styles.container} testID="ask-career-scout-starters-section">
        <Heading level={3} sx={styles.heading}>
          {gt.gettext("Ask Career Scout")}
        </Heading>
        <CareerScoutStarters horizontalBleedInset={spacing.s4} />
      </Box>
      <ViewJobDivider />
    </>
  );
};

const styles = StyleSheet.create({
  container: {
    marginBlockStart: spacing.s4,
    marginBlockEnd: spacing.s5,
    gap: spacing.s3,
  },
  heading: {
    fontSize: 20,
    fontWeight: "700",
    lineHeight: 30,
    letterSpacing: 0,
    color: colors.foregroundStrong,
  },
});
